import {
  getMenuList,
} from '@/api/menu';
import { SNACKBAR_TYPES } from '@/utils/constants';
import { ERROR_RECORD_NOT_FOUND } from '@/utils/errorCodeList';
import { formatMemberOrders, formatMenu, formatMenuList } from '@/utils/helper';

import {
  CLEAR_CART_MENU,
  GET_CART_MENU_DONE,
  GET_CART_MENU,
  GET_FORMATTED_MENU_LIST_DONE,
  GET_FORMATTED_MENU_LIST,
  GET_MEMBER_ORDERS_DONE,
  GET_MENU_DONE,
  GET_MENU_LIST_DONE,
  GET_MENU_LIST,
  GET_MENU,
  GETTING_CART_MENU,
  GETTING_MENU_LIST,
  GETTING_MENU,
  SET_ACTIVATED_CATEGORY,
  SET_ACTIVATED_CATEGORY_DONE,
} from './constants';

export default {
  async [GET_CART_MENU]({ commit, dispatch }, { cb, key }) {
    try {
      commit(GETTING_CART_MENU, true);
      const res = await cb(key);
      commit(GET_CART_MENU_DONE, formatMenu(res));
      return Promise.resolve();
    } catch (error) {
      const { message: msg, status } = error;
      if (status === ERROR_RECORD_NOT_FOUND) {
        dispatch('cart/CLEAR_CART_ITEMS', null, { root: true });
      }

      commit(GET_CART_MENU_DONE, {});
      const { _vm: vm } = this;
      vm.$snackbar({ type: SNACKBAR_TYPES.ERROR, msg });
      return Promise.reject(error);
    } finally {
      commit(GETTING_CART_MENU, false);
    }
  },
  async [GET_MENU]({ commit }, { cb, key }) {
    commit(GETTING_MENU, true);
    try {
      const res = await cb(key);
      commit(GET_MEMBER_ORDERS_DONE, formatMemberOrders(res));
      commit(GET_MENU_DONE, formatMenu(res));
      commit(GETTING_MENU, false);
      return Promise.resolve();
    } catch (error) {
      commit(GET_MEMBER_ORDERS_DONE, {});
      commit(GET_MENU_DONE, {});
      commit(GETTING_MENU, false);
      return Promise.reject(error);
    }
  },
  async [GET_MENU_LIST]({ commit, dispatch }, type) {
    commit(GETTING_MENU_LIST, true);
    try {
      const res = await getMenuList(type);
      commit(GET_MENU_LIST_DONE, res);
      dispatch(GET_FORMATTED_MENU_LIST, res);
      commit(GETTING_MENU_LIST, false);
      return Promise.resolve();
    } catch (error) {
      commit(GET_MENU_LIST_DONE, {});
      commit(GETTING_MENU_LIST, false);
      return Promise.reject(error);
    }
  },
  [CLEAR_CART_MENU]({ commit }) {
    commit(GET_CART_MENU_DONE, {});
  },
  [GET_FORMATTED_MENU_LIST]({ commit }, menuList = []) {
    commit(GET_FORMATTED_MENU_LIST_DONE, formatMenuList(menuList));
  },
  [SET_ACTIVATED_CATEGORY]({ commit }, categoryId) {
    commit(SET_ACTIVATED_CATEGORY_DONE, categoryId);
  },
};
